import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbAccordion, NgbActiveModal, NgbModal, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CityModel, CustomerDetailsViewModel } from 'projects/Administration/src/app/business-entities/customer-view.model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { CustomerDetailsForVehicleViewModel, VehicleCustomerMappingModel } from '../../../../business-entities/Customer-detail.model';
import { CustomerComponent } from '../../../customer/customer.component';
import { ViewCustomerComponent } from '../../../customer/view-customer/view-customer.component';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { ModuleNames } from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html'
})
export class CustomerDetailComponent implements OnInit {

  @ViewChild('acc') accordion!: NgbAccordion;
  vehicleId: number;
  vinNo:string;
  vehicleGuid: string;
  licencePlate:string;
  customerDetails: CustomerDetailsForVehicleViewModel;

  editCustomerPayerForm: FormGroup;
  editCustomerOwnerForm: FormGroup;
  editCustomerUserForm: FormGroup;
  editCustomerDriverForm: FormGroup;

  dobPayer: string;
  dobOwner: string;
  dobUser: string;
  dobDriver: string;

  userInputMobilecodePayer?: string = '';
  userInputMobilecodeOwner?: string = '';
  userInputMobilecodeUser?: string = '';
  userInputMobilecodeDriver?: string = '';

  userInputPhoneNumberCodePayer?: string = '';
  userInputPhoneNumberCodeOwner?: string = '';
  userInputPhoneNumberCodeUser?: string = '';
  userInputPhoneNumberCodeDriver?: string = '';

  editPayer = false;
  editOwner = false;
  editUser = false;
  editDriver = false;

  endDate: string;
  postCodeRawData: any;
  postCodeListPayer: any;
  postcodeNamePayer: string;
  postCodeListOwner: any;
  postcodeNameOwner: string;
  postCodeListUser: any;
  postcodeNameUser: string;
  postCodeListDriver: any;
  postcodeNameDriver: string;

  cityListPayer: CityModel[];
  cityNamePayer: string;
  cityListOwner: CityModel[];
  cityNameOwner: string;
  cityListUser: CityModel[];
  cityNameUser: string;
  cityListDriver: CityModel[];
  cityNameDriver: string;
  features: Features[] = [];
  customerDetailById: CustomerDetailsViewModel;
  countryList: any;
  contactCustomer:any={
    customerName:'',
    dialCode:'',
    mobileNo:''
  };
  integrationWithDMS: boolean = false;
  realtimeDmsSyncVehicle: boolean = false;
  realtimeDmsSyncCustomer: boolean = false;
  vehicleContractStartDate:any;
  vehicleContractEndDate:any;
  Status: boolean = false;
  popupCloseResult = false;
  subscription : Subscription;
  hidePayerAndDriver = false;
  _clientName: string;

  ownerGuid: string;
  CountryISO = CountryISO;
  isInitialLoadMobilePayer: boolean= true;
  isInitialLoadMobileOwner: boolean= true;
  isInitialLoadMobileUser: boolean= true;
  isInitialLoadMobileDriver: boolean= true;  
  isInitialLoadPhonePayer: boolean= true;
  isInitialLoadPhoneOwner: boolean= true;
  isInitialLoadPhoneUser: boolean= true;
  isInitialLoadPhoneDriver: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISOMobilePayer= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOPhonePayer= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOMobileOwner= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOPhoneOwner= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOMobileUser= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOPhoneUser= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOMobileDriver= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOPhoneDriver= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  customerMessage:any=null;
  userRelations:any = null;
  duplicateCustomerList:any;
  currentDate:any = new Date();
  @ViewChild('customerDuplication') customerDuplication: ElementRef;
  constructor(
    private readonly formBuilder: FormBuilder,
    public vehicleBusinessService: VehicleBusinessService,
    private readonly spinner: NgxSpinnerService,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly cdref: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly service: CustomerService,
    private readonly secureStorage: SecureStorage,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly settingService: SettingService
  ) { }

  ngOnInit(): void {
    if(this.vehicleBusinessService.searchThroughLocalDF){
      this.onSearchCustomerNo(this.vehicleBusinessService.existingCustomerNo,'Owner');
    }
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this._clientName = localStorage.getItem("Theme");
    this.hidePayerAndDriver = localStorage.getItem("Theme") === 'mg';
    this.vehicleId = this.vehicleBusinessService.vehicleId;
    this.vehicleGuid = this.vehicleBusinessService.vehicleGuid;
    this.vinNo=this.vehicleBusinessService.vinNo;
    this.licencePlate = this.vehicleBusinessService.licensePlate
    this.endDate = Utility.GetFormattedDate(new Date());
    this.initializeForm();
    this.getPostCodeDropdown();
    this.countryDropdownDetails();
    this.getFeatures();
    this.getCustomerDetail(this.vehicleId);
  }
  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
        if (this.features?.length > 0) {
          this.integrationWithDMS = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          this.realtimeDmsSyncCustomer = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive;
          this.realtimeDmsSyncVehicle = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSV)?.isActive;
        }
      })
    }else{
      this.integrationWithDMS = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
      this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      this.realtimeDmsSyncCustomer = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive;
      this.realtimeDmsSyncVehicle = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSV)?.isActive;
    }
  }


  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("",'Payer');
      this.BindCityData("",'Payer');
      this.BindPostData("",'Owner');
      this.BindCityData("",'Owner');
      this.BindPostData("",'User');
      this.BindCityData("",'User');
      this.BindPostData("",'Driver');
      this.BindCityData("",'Driver');
    } 
    this.spinner.hide();
  }

  async countryDropdownDetails(): Promise<void> {
    await this.service.getCountryCodeAndMobileCodeDetails()
      .then((response) => {
          this.spinner.hide();
            this.countryList =  response?.responseObject?.result.filter(x => x.isDisplay);
      }, _error => {
        this.spinner.hide();
      });
  }

  BindPostData(city,flag:string) {
    switch (flag) {
      case 'Payer':
        this.postCodeListPayer = this.postCodeList(this.postCodeRawData, city);
        this.postcodeNamePayer = this.defaultPostCodeName(this.postCodeListPayer, this.postcodeNamePayer);
        break;
      case 'Owner':
        this.postCodeListOwner = this.postCodeList(this.postCodeRawData, city);
        this.postcodeNameOwner = this.defaultPostCodeName(this.postCodeListOwner, this.postcodeNameOwner);
        break;
      case 'User':
        this.postCodeListUser = this.postCodeList(this.postCodeRawData, city);
        this.postcodeNameUser = this.defaultPostCodeName(this.postCodeListUser, this.postcodeNameUser);
        break;
      case 'Driver':
        this.postCodeListDriver = this.postCodeList(this.postCodeRawData, city);
        this.postcodeNameDriver = this.defaultPostCodeName(this.postCodeListDriver, this.postcodeNameDriver);
        break;
      default:
        break;
    }
  }
  private  postCodeList(rawData, city) {
    return city?.trim() ? rawData.filter(f => f.city === city) : rawData;
  }
 private defaultPostCodeName(codeList, currentPostcodeName) {
    if (currentPostcodeName?.length === 0 && codeList.length > 0) {
      return codeList[0]?.code;
    }
    return currentPostcodeName;
  }
  BindCityData(post,flag:string) {
    switch (flag) {
      case 'Payer':
        if (post?.trim()) {
          let postdata = this.postCodeRawData.filter(f => f.code == post);
          this.cityListPayer = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.onCitySelected(this.cityListPayer[0],flag)
        } else {
          this.cityListPayer = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
        }
        break;
      case 'Owner':
        if ( post?.trim()) {
          let postdata = this.postCodeRawData.filter(f => f.code == post);
          this.cityListOwner = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.onCitySelected(this.cityListOwner[0],flag)
        } else {
          this.cityListOwner = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
        }
        break;
      case 'User':
        if (post?.trim()) {
          let postdata = this.postCodeRawData.filter(f => f.code == post);
          this.cityListUser = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.onCitySelected(this.cityListUser[0],flag)
        } else {
          this.cityListUser = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
        }
        break;
      case 'Driver':
        if (post?.trim()) {
          let postdata = this.postCodeRawData.filter(f => f.code == post);
          this.cityListDriver = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.onCitySelected(this.cityListDriver[0],flag)
        } else {
          this.cityListDriver = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
        }
        break;
      default:
        break;
    }
  }

  async onCitySelected(city: any,flag:string) {
    switch (flag) {
      case 'Payer':
        this.cityNamePayer = city;
        if (city?.trim()) {
          this.BindPostData(city,flag);
        } else {
          this.cityListPayer = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.postcodeNamePayer = "";
        }
        break;
      case 'Owner':
        this.cityNameOwner = city;
        if (city?.trim()) {
          this.BindPostData(city,flag);
        } else {
          this.cityListOwner = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.postcodeNameOwner = "";
        }
        break;
      case 'User':
        this.cityNameUser = city;
        if (city?.trim()) {
          this.BindPostData(city,flag);
        } else {
          this.cityListUser = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.postcodeNameUser = "";
        }
        break;
      case 'Driver':
        this.cityNameDriver = city;
        if (city?.trim()) {
          this.BindPostData(city,flag);
        } else {
          this.cityListDriver = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          this.postcodeNameDriver = "";
        }
        break;
      default:
        break;
    }
  }

  async onPostCodeSelected(postCode: string,flag:string) {
    switch (flag) {
      case 'Payer':
        this.postcodeNamePayer = postCode;
        if (postCode?.trim()) {
          this.BindCityData(postCode,flag);
        } else {
          this.postCodeListPayer = this.postCodeRawData;
          this.cityNamePayer = "";
        }
        break;
      case 'Owner':
        this.postcodeNameOwner = postCode;
        if (postCode?.trim()) {
          this.BindCityData(postCode,flag);
        } else {
          this.postCodeListOwner = this.postCodeRawData;
          this.cityNameOwner = "";
        }
        break;
      case 'User':
        this.postcodeNameUser = postCode;
        if (postCode?.trim()) {
          this.BindCityData(postCode,flag);
        } else {
          this.postCodeListUser = this.postCodeRawData;
          this.cityNameUser = "";
        }
        break;
      case 'Driver':
        this.postcodeNameDriver = postCode;
        if (postCode?.trim()) {
          this.BindCityData(postCode,flag);
        } else {
          this.postCodeListDriver = this.postCodeRawData;
          this.cityNameDriver = "";
        }
        break;
      default:
        break;
    }

  }

  async getCustomerDetail(vehicleId: number): Promise<void> {
    this.spinner.show();
    await this.vehicleBusinessService.getCustomerDetailByVehicleId(vehicleId).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.customerDetails = response.responseObject;
        this.enableDisableControls();
        this.processDetailAsPerCustomerType();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.ServicecategoriesNotFound) {
          let ErrorMsg = this.translate.instant('lblCustomerDetailNotFound');
          this.toaster.error(ErrorMsg);
        }
      }
      this.spinner.hide();
    });
  }
  processDetailAsPerCustomerType(){
    if (this.customerDetails.customerPayer != null) {
      this.customerDetails.customerPayer.dialCode=this.customerDetails.customerPayer.dialCode?.replace('+','');
      this.customerDetails.customerPayer.phoneNumberCode=this.customerDetails.customerPayer.phoneNumberCode?.replace('+','');
      this.patchCutomerPayerForm();
    }
    if (this.customerDetails.customerOwner != null) {
      this.customerDetails.customerOwner.dialCode=this.customerDetails.customerOwner.dialCode?.replace('+','');
      this.customerDetails.customerOwner.phoneNumberCode=this.customerDetails.customerOwner.phoneNumberCode?.replace('+','');
      this.patchCutomerOwnerForm();
    }
    if (this.customerDetails.customerUser != null) {
      this.customerDetails.customerUser.dialCode=this.customerDetails.customerUser.dialCode?.replace('+','');
      this.customerDetails.customerUser.phoneNumberCode=this.customerDetails.customerUser.phoneNumberCode?.replace('+','');
      this.patchCutomerUserForm();
    }
    if (this.customerDetails.customerDriver != null) {
      this.customerDetails.customerDriver.dialCode=this.customerDetails.customerDriver.dialCode?.replace('+','');
      this.customerDetails.customerDriver.phoneNumberCode=this.customerDetails.customerDriver.phoneNumberCode?.replace('+','');
      this.patchCutomerDriverForm();
    }
    if (this.customerDetails.serviceContractCustomer != null) {
      this.vehicleContractStartDate = this.customerDetails.serviceContractCustomer.startDate ? new Date(this.customerDetails.serviceContractCustomer.startDate + 'Z') : null;
      this.vehicleContractEndDate = this.customerDetails.serviceContractCustomer.expiredDate ? new Date(this.customerDetails.serviceContractCustomer.expiredDate + 'Z') : null;
      if(this.vehicleContractEndDate){
        this.Status = this.vehicleContractEndDate >= new Date() ? true : false;
      }
    }
  }

  changeCustomerType(_event: Event) {
    this.enableDisableControls();
  }

  enableDisableControls() {
    if (this.editCustomerPayerForm.value.isCompany) {

      this.editCustomerPayerForm.controls.lastName.clearValidators();
      this.editCustomerPayerForm.controls.lastName.updateValueAndValidity();
      this.editCustomerPayerForm.controls.firstName.clearValidators();
      this.editCustomerPayerForm.controls.firstName.updateValueAndValidity();

      this.editCustomerPayerForm.controls.customerName.setValidators([Validators.required]);
      this.editCustomerPayerForm.controls.customerName.updateValueAndValidity();
    } else {

      this.editCustomerPayerForm.controls.customerName.clearValidators();
      this.editCustomerPayerForm.controls.customerName.updateValueAndValidity();
      this.editCustomerPayerForm.controls.lastName.setValidators([Validators.required]);
      this.editCustomerPayerForm.controls.lastName.updateValueAndValidity();
      this.editCustomerPayerForm.controls.firstName.setValidators([Validators.required]);
      this.editCustomerPayerForm.controls.firstName.updateValueAndValidity();
    }
    if (this.editCustomerOwnerForm.value.isCompany) {

      this.editCustomerOwnerForm.controls.lastName.clearValidators();
      this.editCustomerOwnerForm.controls.lastName.updateValueAndValidity();
      this.editCustomerOwnerForm.controls.firstName.clearValidators();
      this.editCustomerOwnerForm.controls.firstName.updateValueAndValidity();

      this.editCustomerOwnerForm.controls.customerName.setValidators([Validators.required]);
      this.editCustomerOwnerForm.controls.customerName.updateValueAndValidity();
    } else {

      this.editCustomerOwnerForm.controls.customerName.clearValidators();
      this.editCustomerOwnerForm.controls.customerName.updateValueAndValidity();

      this.editCustomerOwnerForm.controls.lastName.setValidators([Validators.required]);
      this.editCustomerOwnerForm.controls.lastName.updateValueAndValidity();
      this.editCustomerOwnerForm.controls.firstName.setValidators([Validators.required]);
      this.editCustomerOwnerForm.controls.firstName.updateValueAndValidity();
    }
    if (this.editCustomerDriverForm.value.isCompany) {

      this.editCustomerDriverForm.controls.lastName.clearValidators();
      this.editCustomerDriverForm.controls.lastName.updateValueAndValidity();
      this.editCustomerDriverForm.controls.firstName.clearValidators();
      this.editCustomerDriverForm.controls.firstName.updateValueAndValidity();

      this.editCustomerDriverForm.controls.customerName.setValidators([Validators.required]);
      this.editCustomerDriverForm.controls.customerName.updateValueAndValidity();
    } else {

      this.editCustomerDriverForm.controls.customerName.clearValidators();
      this.editCustomerDriverForm.controls.customerName.updateValueAndValidity();

      this.editCustomerDriverForm.controls.lastName.setValidators([Validators.required]);
      this.editCustomerDriverForm.controls.lastName.updateValueAndValidity();
      this.editCustomerDriverForm.controls.firstName.setValidators([Validators.required]);
      this.editCustomerDriverForm.controls.firstName.updateValueAndValidity();
    }
    if (this.editCustomerUserForm.value.isCompany) {

      this.editCustomerUserForm.controls.lastName.clearValidators();
      this.editCustomerUserForm.controls.lastName.updateValueAndValidity();
      this.editCustomerUserForm.controls.firstName.clearValidators();
      this.editCustomerUserForm.controls.firstName.updateValueAndValidity();

      this.editCustomerUserForm.controls.customerName.setValidators([Validators.required]);
      this.editCustomerUserForm.controls.customerName.updateValueAndValidity();
    } else {

      this.editCustomerUserForm.controls.customerName.clearValidators();
      this.editCustomerUserForm.controls.customerName.updateValueAndValidity();

      this.editCustomerUserForm.controls.lastName.setValidators([Validators.required]);
      this.editCustomerUserForm.controls.lastName.updateValueAndValidity();
      this.editCustomerUserForm.controls.firstName.setValidators([Validators.required]);
      this.editCustomerUserForm.controls.firstName.updateValueAndValidity();
    }
  }

  patchCutomerPayerForm() {
    this.editCustomerPayerForm.patchValue({
      ...this.customerDetails.customerPayer,
    })
    this.postcodeNamePayer=this.customerDetails.customerPayer.postCode;
    this.cityNamePayer=this.customerDetails.customerPayer.city;
    this.dobPayer = this.customerDetails.customerPayer.dob ? Utility.GetFormattedDate(this.customerDetails.customerPayer.dob) : this.dobPayer;
    this.editCustomerPayerForm.patchValue({
      dob: this.dobPayer,
      gender: this.customerDetails.customerPayer.customerTypeId ==  1 ? '1' : '0'
    })
    this.userInputMobilecodePayer = this.customerDetails.customerPayer.dialCode !== null && this.customerDetails.customerPayer.dialCode !== '0' ? this.customerDetails.customerPayer.dialCode : this.userInputMobilecodePayer;
    this.telInputObjectPayer();

    this.userInputPhoneNumberCodePayer = this.customerDetails.customerPayer.phoneNumberCode !== null && this.customerDetails.customerPayer.phoneNumberCode !== '0' ? this.customerDetails.customerPayer.phoneNumberCode : this.userInputPhoneNumberCodePayer;
    this.telInputObjectPayer();

    this.cdref.detectChanges();

  }

  patchCutomerOwnerForm() {
    this.editCustomerOwnerForm.patchValue({
      ...this.customerDetails.customerOwner,
    })
    this.postcodeNameOwner=this.customerDetails.customerOwner.postCode;
    this.cityNameOwner=this.customerDetails.customerOwner.city;
    this.dobOwner = this.customerDetails.customerOwner.dob ? Utility.GetFormattedDate(this.customerDetails.customerOwner.dob) : this.dobOwner;
    this.editCustomerOwnerForm.patchValue({
      dob: this.dobOwner,
      gender: this.customerDetails.customerOwner.customerTypeId ==  1 ? '1' : '0'
    })
    this.userInputMobilecodeOwner = this.customerDetails.customerOwner.dialCode !== null && this.customerDetails.customerOwner.dialCode !== '0' ? this.customerDetails.customerOwner.dialCode : this.userInputMobilecodeOwner;
    this.telInputObjectOwner();
    this.cdref.detectChanges();
  }

  patchCutomerUserForm() {
    this.editCustomerUserForm.patchValue({
      ...this.customerDetails.customerUser,
    })
    this.postcodeNameUser=this.customerDetails.customerUser.postCode;
    this.cityNameUser=this.customerDetails.customerUser.city;
    this.dobUser = this.customerDetails.customerUser.dob ? Utility.GetFormattedDate(this.customerDetails.customerUser.dob) : this.dobUser;
    this.editCustomerUserForm.patchValue({
      dob: this.dobUser,
      gender: this.customerDetails.customerUser.customerTypeId ==  1 ? '1' : '0'
    })
    this.userInputMobilecodeUser = this.customerDetails.customerUser.dialCode !== null && this.customerDetails.customerUser.dialCode !== '0' ? this.customerDetails.customerUser.dialCode : this.userInputMobilecodeUser;
    this.telInputObjectUser();
    this.cdref.detectChanges();
  }

  patchCutomerDriverForm() {
    this.editCustomerDriverForm.patchValue({
      ...this.customerDetails.customerDriver,
    })
    this.postcodeNameDriver=this.customerDetails.customerDriver.postCode;
    this.cityNameDriver=this.customerDetails.customerDriver.city;
    this.dobDriver = this.customerDetails.customerDriver.dob ? Utility.GetFormattedDate(this.customerDetails.customerDriver.dob) : this.dobDriver;
    this.editCustomerDriverForm.patchValue({
      dob: this.dobDriver,
      gender: this.customerDetails.customerDriver.customerTypeId ==  1 ? '1' : '0'
    })
    this.userInputMobilecodeDriver = this.customerDetails.customerDriver.dialCode !== null && this.customerDetails.customerDriver.dialCode !== '0' ? this.customerDetails.customerDriver.dialCode : this.userInputMobilecodeDriver;
    this.telInputObjectDriver();
    this.cdref.detectChanges();
  }

  initializeForm(): void {
    this.editCustomerPayerForm = this.formBuilder.group({
      customerId:[''],
      isCompany: [false],
      customerNo: [''],
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      customerName:new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
      address2: [''],
      city: new FormControl('', [Validators.required]),
      postCode: new FormControl('', [Validators.required]),
      dialCode: [''],
      mobileNo: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]),
      dob: [''],
      ownerType: [''],
      ownerTypeId:[''],
      gender:new FormControl('0')
    });
    this.editCustomerOwnerForm = this.formBuilder.group({
      customerId:[''],
      isCompany: [false],
      customerNo: [''],
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      customerName: new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
      address2: [''],
      city: new FormControl('', [Validators.required]),
      postCode: new FormControl('', [Validators.required]),
      dialCode: [''],
      mobileNo:new FormControl('', [Validators.required]),
      phoneNumber:new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]),
      dob: [''],
      ownerType: [''],
      ownerTypeId:[''],
      gender:['0']
    });
    this.editCustomerUserForm = this.formBuilder.group({
      customerId:[''],
      isCompany: [false],
      customerNo: [''],
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      customerName: new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
      address2: [''],
      city: new FormControl('', [Validators.required]),
      postCode: new FormControl('', [Validators.required]),
      dialCode: [''],
      mobileNo: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]),
      dob: [''],
      ownerType: [''],
      ownerTypeId:[''],
      gender:['0']
    });
    this.editCustomerDriverForm = this.formBuilder.group({
      customerId:[''],
      isCompany: [{value:false, disabled: true}],
      customerNo: [''],
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      customerName: new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
      address2: [''],
      city: new FormControl('', [Validators.required]),
      postCode: new FormControl('', [Validators.required]),
      dialCode: [''],
      mobileNo: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]),
      dob: [''],
      ownerType: [''],
      ownerTypeId:[''],
      gender:['0']
    });
    this.telInputObjectPayer();
    this.telInputObjectOwner();
    this.telInputObjectUser();
    this.telInputObjectDriver();
    this.telInputObjectPhoneNumberPayer();
    this.telInputObjectPhoneNumberOwner();
    this.telInputObjectPhoneNumberUser();
    this.telInputObjectPhoneNumberDriver();
    this.editCustomerUserForm.disable();
    this.editCustomerUserForm.controls['customerNo'].enable();
    this.editCustomerUserForm.controls['customerId'].enable();
    this.editCustomerOwnerForm.disable();
    this.editCustomerOwnerForm.controls['customerNo'].enable();
    this.editCustomerOwnerForm.controls['customerId'].enable();
    this.editCustomerDriverForm.disable();
    this.editCustomerDriverForm.controls['customerNo'].enable();
    this.editCustomerDriverForm.controls['customerId'].enable();
    this.editCustomerPayerForm.disable();
    this.editCustomerPayerForm.controls['customerNo'].enable();
    this.editCustomerPayerForm.controls['customerId'].enable();
    this.cdref.detectChanges();
  }

  telInputObjectPayer() {
      if (this.userInputMobilecodePayer) {
        this.userInputMobilecodePayer=this.userInputMobilecodePayer.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecodePayer);
        this.selectedCountryISOMobilePayer= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOMobilePayer= this.cultureLocaleService.getLocale();
  }
  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  telInputObjectOwner() {
      if (this.userInputMobilecodeOwner) {
        this.userInputMobilecodeOwner=this.userInputMobilecodeOwner.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecodeOwner);
        this.selectedCountryISOMobileOwner= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOMobileOwner= this.cultureLocaleService.getLocale();
    
  }

  telInputObjectUser() {
      if (this.userInputMobilecodeUser) {
        this.userInputMobilecodeUser=this.userInputMobilecodeUser.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecodeUser);
        this.selectedCountryISOMobileUser= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOMobileUser= this.cultureLocaleService.getLocale();
    
  }

  telInputObjectDriver() {
      if (this.userInputMobilecodeDriver) {
        this.userInputMobilecodeDriver=this.userInputMobilecodeDriver.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecodeDriver);
        this.selectedCountryISOMobileDriver= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOMobileDriver= this.cultureLocaleService.getLocale();
    
  }

  telInputObjectPhoneNumberPayer() {
      if (this.userInputPhoneNumberCodePayer) {
        this.userInputPhoneNumberCodePayer=this.userInputPhoneNumberCodePayer.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputPhoneNumberCodePayer);
        this.selectedCountryISOPhonePayer= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOPhonePayer= this.cultureLocaleService.getLocale();
  }

  telInputObjectPhoneNumberOwner() {
      if (this.userInputPhoneNumberCodeOwner) {
        this.userInputPhoneNumberCodeOwner=this.userInputPhoneNumberCodeOwner.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputPhoneNumberCodeOwner);
        this.selectedCountryISOPhoneOwner= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOPhoneOwner= this.cultureLocaleService.getLocale();
  }

  telInputObjectPhoneNumberUser() {
      if (this.userInputPhoneNumberCodeUser) {
        this.userInputPhoneNumberCodeUser=this.userInputPhoneNumberCodeUser.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputPhoneNumberCodeUser);
        this.selectedCountryISOPhoneUser= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
      this.selectedCountryISOPhoneUser= this.cultureLocaleService.getLocale();
  }

  telInputObjectPhoneNumberDriver() {
      if (this.userInputPhoneNumberCodeDriver) {
        this.userInputPhoneNumberCodeDriver=this.userInputPhoneNumberCodeDriver.replace('+','');
        let countryCode = this.getCountryCodeByDialCode(this.userInputPhoneNumberCodeDriver);
        this.selectedCountryISOPhoneDriver= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOPhoneDriver= this.cultureLocaleService.getLocale();
  }

  onCountryChange(obj, flag: string) {
    switch (flag) {
      case 'Payer':
        if (this.isInitialLoadMobilePayer) {
          this.telInputObjectPayer();
          this.userInputMobilecodePayer = this.userInputMobilecodePayer || obj.dialCode;
          this.isInitialLoadMobilePayer = false;
        } else {
          this.userInputMobilecodePayer = obj.dialCode;
        }
        break;
      case 'Owner':
        if (this.isInitialLoadMobileOwner) {
        this.telInputObjectOwner();
        this.userInputMobilecodeOwner = this.userInputMobilecodeOwner || obj.dialCode;
        this.isInitialLoadMobileOwner = false;
      } else {
        this.userInputMobilecodeOwner = obj.dialCode;
      }
        break;
      case 'User':
        if (this.isInitialLoadMobileUser) {
        this.telInputObjectUser();
        this.userInputMobilecodeUser = this.userInputMobilecodeUser || obj.dialCode;
        this.isInitialLoadMobileUser = false;
      } else {
        this.userInputMobilecodeUser = obj.dialCode;
      }
        break;
      case 'Driver':
        if (this.isInitialLoadMobileDriver) {
        this.telInputObjectDriver();
        this.userInputMobilecodeDriver = this.userInputMobilecodeDriver || obj.dialCode;
        this.isInitialLoadMobileDriver = false;
      } else {
        this.userInputMobilecodeDriver = obj.dialCode;
      }
        break;
      default:
        break;
    }

  }

  onCountryChangePhoneNumber(obj, flag: string)
  {
    switch (flag) {
      case 'Payer':
        if (this.isInitialLoadPhonePayer) {
          this.telInputObjectPhoneNumberPayer();
          this.userInputPhoneNumberCodePayer = this.userInputPhoneNumberCodePayer || obj.dialCode;
          this.isInitialLoadPhonePayer = false;
        } else {
          this.userInputPhoneNumberCodePayer = obj.dialCode;
        }
        break;
      case 'Owner':
        if (this.isInitialLoadPhoneOwner) {
          this.telInputObjectPhoneNumberOwner();
          this.userInputPhoneNumberCodeOwner = this.userInputPhoneNumberCodeOwner || obj.dialCode;
          this.isInitialLoadPhoneOwner = false;
        } else {
          this.userInputPhoneNumberCodeOwner = obj.dialCode;
        }
        break;
      case 'User':
        if (this.isInitialLoadPhoneUser) {
          this.telInputObjectPhoneNumberUser();
          this.userInputPhoneNumberCodeUser = this.userInputPhoneNumberCodeUser || obj.dialCode;
          this.isInitialLoadPhoneUser = false;
        } else {
          this.userInputPhoneNumberCodeUser = obj.dialCode;
        }
        break;
      case 'Driver':
        if (this.isInitialLoadPhoneDriver) {
          this.telInputObjectPhoneNumberDriver();
          this.userInputPhoneNumberCodeDriver = this.userInputPhoneNumberCodeDriver || obj.dialCode;
          this.isInitialLoadPhoneDriver = false;
        } else {
          this.userInputPhoneNumberCodeDriver = obj.dialCode;
        }
        break;
      default:
        break;
    }
  }

  changeTitle($event: NgbPanelChangeEvent, acc) {
    this.isEditMethod($event.panelId)
    if($event.panelId === "Owner" && this.editOwner && acc.isExpanded($event.panelId)) {
      $event.preventDefault()
     }
     if($event.panelId === "Payer" && this.editPayer && acc.isExpanded($event.panelId)) {
      $event.preventDefault()
     }
     if($event.panelId === "User" && this.editUser && acc.isExpanded($event.panelId)) {
      $event.preventDefault()
     }
     if($event.panelId === "Driver" && this.editDriver && acc.isExpanded($event.panelId)) {
      $event.preventDefault()
     }
  }

  async isEditMethod(flag: string,isEdit=false) {
    let customerId:number=0;
    if(isEdit)
    {
    switch (flag) {
      case 'Payer':
        this.editCustomerPayerForm.enable();
        this.editCustomerPayerForm.controls['customerNo'].disable();
        this.editPayer = true;

        this.editOwner = false;
        this.editUser = false;
        this.editDriver = false;
        this.editCustomerUserForm.disable();
        this.editCustomerOwnerForm.disable();
        this.editCustomerDriverForm.disable();
        customerId=this.editCustomerPayerForm.controls['customerId'].value;
        break;
      case 'Owner':
        this.editCustomerOwnerForm.enable();
        this.editCustomerOwnerForm.controls['customerNo'].disable();
        this.editOwner = true;

        this.editPayer = false;
        this.editUser = false;
        this.editDriver = false;
        this.editCustomerUserForm.disable();
        this.editCustomerDriverForm.disable();
        this.editCustomerPayerForm.disable();
        customerId=this.editCustomerOwnerForm.controls['customerId'].value;
        break;
      case 'User':
        this.editCustomerUserForm.enable();
        this.editCustomerUserForm.controls['customerNo'].disable();
        this.editUser = true;

        this.editOwner = false;
        this.editPayer = false;
        this.editDriver = false;
        this.editCustomerOwnerForm.disable();
        this.editCustomerDriverForm.disable();
        this.editCustomerPayerForm.disable();
        customerId=this.editCustomerUserForm.controls['customerId'].value;
        break;
      case 'Driver':
        this.editCustomerDriverForm.enable();
        this.editCustomerDriverForm.controls['customerNo'].disable();
        this.editDriver = true;

        this.editUser = false;
        this.editOwner = false;
        this.editPayer = false;
        this.editCustomerUserForm.disable();
        this.editCustomerOwnerForm.disable();
        this.editCustomerPayerForm.disable();
        customerId=this.editCustomerDriverForm.controls['customerId'].value;
        break;
      default:
        break;
    }
  }

    if(customerId!=0)
    {
      await this.service.getCustomerById(customerId).then((response) => {
        this.customerDetailById = response.responseObject as CustomerDetailsViewModel;
        this.spinner.hide();
      },_error => {
        this.spinner.hide();
      });
    }

  }
  DeleteRelation(flag:string,customerDetail) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblLinkageBtwCustomerVehicle"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.DeleteMapping(flag,customerDetail)
      }
    });
  }
  DeleteMapping(flag:string,customerDetail){
    let vehileInfo =
    {
      vehicleId: this.vehicleId,
      customerId: customerDetail.customerId,
      customerNo: customerDetail.customerNo,
      chassisNo: this.vinNo,
      integrationWithDMS: false,
      moduleId: ModuleNames.Vehicle,
      ownerTypeId: customerDetail.ownerTypeId,
      realtimeDmsSyncVehicle:true
    }

    if (this.features && this.features.length > 0) {
      let feature = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
      this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
      vehileInfo.integrationWithDMS = feature;
      let realTimeSync = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSV)?.isActive
      vehileInfo.realtimeDmsSyncVehicle = realTimeSync;
    }
    this.spinner.show();
    this.vehicleBusinessService.UnmapCustomerVehicle(vehileInfo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        let successMsg = this.translate.instant('lblVehicleUnmappedSuccess')
        this.toaster.success(successMsg);
        switch (flag){
          case 'Payer':
            this.customerDetails.customerPayer = null;
            this.editCustomerPayerForm.reset();
            this.postcodeNamePayer = '';
            this.cityNamePayer = '';
            this.dobPayer = '';
            break;
          case 'Owner':
            this.customerDetails.customerOwner = null;
            this.editCustomerOwnerForm.reset();
            this.postcodeNameOwner = '';
            this.cityNameOwner = '';
            this.dobOwner = '';
            break;
          case 'User':
            this.customerDetails.customerUser = null;
            this.editCustomerUserForm.reset();
            this.postcodeNameUser = '';
            this.cityNameUser = '';
            this.dobUser = '';
            break;
          case 'Driver':
            this.customerDetails.customerDriver = null;
            this.editCustomerDriverForm.reset();
            this.postcodeNameDriver = '';
            this.cityNameDriver = '';
            this.dobDriver = '';
            break;
        }
      }
      this.spinner.hide();
    });
  }
  Cancelform(flag: string) {
    switch (flag) {
      case 'Payer':
        this.patchCutomerPayerForm();
        this.editCustomerPayerForm.disable();
        this.editCustomerPayerForm.controls['customerNo'].enable();
        this.editCustomerPayerForm.controls['customerId'].enable();
        this.editPayer = false;
        break;
      case 'Owner':
        this.patchCutomerOwnerForm();
        this.editCustomerOwnerForm.disable();
        this.editCustomerOwnerForm.controls['customerNo'].enable();
        this.editCustomerOwnerForm.controls['customerId'].enable();
        this.editOwner = false;
        break;
      case 'User':
        this.patchCutomerUserForm();
        this.editCustomerUserForm.disable();
        this.editCustomerUserForm.controls['customerNo'].enable();
        this.editCustomerUserForm.controls['customerId'].enable();
        this.editUser = false;
        break;
      case 'Driver':
        this.patchCutomerDriverForm();
        this.editCustomerDriverForm.disable();
        this.editCustomerDriverForm.controls['customerNo'].enable();
        this.editCustomerDriverForm.controls['customerId'].enable();
        this.editDriver = false;
        break;
      default:
        break;
    }
  }

  async onSaveCustomer(flag: string, customerId: number) {
    this.spinner.show();
    let customerInfo:any;
    const temp = new Date();
    switch (flag) {
      case 'Payer':
        if(this.customerDetailById)
        {
        customerInfo =
        {
          customerId: customerId,
          firstName: this.empty(this.editCustomerPayerForm.get('firstName').value) ? "" : this.editCustomerPayerForm.get('firstName').value,
          lastName: this.empty(this.editCustomerPayerForm.get('lastName').value) ? "" : this.editCustomerPayerForm.get('lastName').value,
          address1: this.editCustomerPayerForm.get('address1').value,
          address2: this.editCustomerPayerForm.get('address2').value,
          zipcode: this.editCustomerPayerForm.get('postCode').value,
          city: this.editCustomerPayerForm.get('city').value,
          state: "",
          countryId: this.customerDetailById.countryId,
          mobileNo: this.editCustomerPayerForm.get('mobileNo').value?.number ? this.editCustomerPayerForm.get('mobileNo').value.number.toString().replace(/\s+/g, '') : this.editCustomerPayerForm.get('mobileNo').value,
          mobileCode: this.empty(this.userInputMobilecodePayer)? "" : this.userInputMobilecodePayer.replace("+", ""),
          email: this.editCustomerPayerForm.get('email').value,
          latitude: 0,
          longitude: 0,
          customerNo: this.editCustomerPayerForm.get('customerNo').value,
          langaugeCode: this.customerDetailById.langaugeCode,
          blocked: this.customerDetailById.blocked,
          phoneNumberCode:this.empty(this.userInputPhoneNumberCodePayer)? "" : this.userInputPhoneNumberCodePayer.replace("+", ""),
          phoneNumber: this.editCustomerPayerForm.get('phoneNumber').value?.number ? this.editCustomerPayerForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '') : this.editCustomerPayerForm.get('phoneNumber').value,
          customerTypeId: this.customerDetailById.customerTypeId,
          custName: "",
          registrationOrPersonNumber: this.customerDetailById.registrationOrPersonNumber,
          registrationOrBirthDate: this.customerDetailById.registrationOrBirthDate,
          customerGroup: this.customerDetailById.customerGroup,
          salutation:  this.customerDetailById.salutation,
          email2: this.customerDetailById.email2,
          fax: this.customerDetailById.fax,
          ownerTypeId: this.customerDetailById.ownerTypeId,
          sourceTypeId: this.customerDetailById.sourceTypeId,
          isActive: this.customerDetailById.isActive,
          isRegularEmail: this.customerDetailById.isRegularEmail,
          isEmail: this.customerDetailById.isEmail,
          isFax: this.customerDetailById.isFax,
          isSms: this.customerDetailById.isSms,
          isPhone: this.customerDetailById.isPhone,
          dataPrivacyStatus: this.customerDetailById.dataPrivacyStatus,
          integrationWithDMS: false,
          moduleId: ModuleNames.Customer,
          countryCode:this.countryList?.find(f => f.id == this.customerDetailById.countryId).code,
          realtimeDmsSyncCustomer:true,
        }
        }
        if (this.features && this.features.length > 0) {
          let feature = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
          customerInfo.integrationWithDMS = feature;
          let realTimeSync = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive
          customerInfo.realtimeDmsSyncCustomer = realTimeSync;
        }
        if (this.editCustomerPayerForm.value.isCompany) {
          customerInfo.customerTypeId = 2;
          customerInfo.custName = this.editCustomerPayerForm.get('customerName').value;
          if (!this.empty(this.editCustomerPayerForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerPayerForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        } else {
          customerInfo.customerTypeId = this.editCustomerPayerForm.get('gender').value == '1' ? 1 : 0;
          customerInfo.custName = this.editCustomerPayerForm.get('firstName').value + " " + this.editCustomerPayerForm.get('lastName').value;
          if (!this.empty(this.editCustomerPayerForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerPayerForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        }
        break;
      case 'Owner':
        if(this.customerDetailById)
        {
        customerInfo =
        {
          customerId: customerId,
          firstName: this.empty(this.editCustomerOwnerForm.get('firstName').value) ? "" : this.editCustomerOwnerForm.get('firstName').value,
          lastName: this.empty(this.editCustomerOwnerForm.get('lastName').value) ? "" : this.editCustomerOwnerForm.get('lastName').value,
          address1: this.editCustomerOwnerForm.get('address1').value,
          address2: this.editCustomerOwnerForm.get('address2').value,
          zipcode: this.editCustomerOwnerForm.get('postCode').value,
          city: this.editCustomerOwnerForm.get('city').value,
          state: "",
          countryId: this.customerDetailById.countryId,
          mobileNo: this.editCustomerOwnerForm.get('mobileNo').value?.number ? this.editCustomerOwnerForm.get('mobileNo').value.number.toString().replace(/\s+/g, '') : this.editCustomerOwnerForm.get('mobileNo').value,
          mobileCode: this.empty(this.userInputMobilecodeOwner)? "" : this.userInputMobilecodeOwner.replace("+", ""),
          email: this.editCustomerOwnerForm.get('email').value,
          latitude: 0,
          longitude: 0,
          customerNo: this.editCustomerOwnerForm.get('customerNo').value,
          langaugeCode: this.customerDetailById.langaugeCode,
          blocked: this.customerDetailById.blocked,
          phoneNumberCode:this.empty(this.userInputPhoneNumberCodeOwner)? "" : this.userInputPhoneNumberCodeOwner.replace("+", ""),
          phoneNumber: this.editCustomerOwnerForm.get('phoneNumber').value?.number ? this.editCustomerOwnerForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '') : this.editCustomerOwnerForm.get('phoneNumber').value,
          customerTypeId: this.customerDetailById.customerTypeId,
          custName: "",
          registrationOrPersonNumber: this.customerDetailById.registrationOrPersonNumber,
          registrationOrBirthDate: this.customerDetailById.registrationOrBirthDate,
          customerGroup: this.customerDetailById.customerGroup,
          salutation:  this.customerDetailById.salutation,
          email2: this.customerDetailById.email2,
          fax: this.customerDetailById.fax,
          ownerTypeId: this.customerDetailById.ownerTypeId,
          sourceTypeId: this.customerDetailById.sourceTypeId,
          isActive: this.customerDetailById.isActive,
          isRegularEmail: this.customerDetailById.isRegularEmail,
          isEmail: this.customerDetailById.isEmail,
          isFax: this.customerDetailById.isFax,
          isSms: this.customerDetailById.isSms,
          isPhone: this.customerDetailById.isPhone,
          dataPrivacyStatus: this.customerDetailById.dataPrivacyStatus,
          integrationWithDMS: false,
          moduleId: ModuleNames.Customer,
          countryCode:this.countryList?.find(f => f.id == this.customerDetailById.countryId).code,
          realtimeDmsSyncCustomer:true,
        }
        }
        if (this.features && this.features.length > 0) {
          let feature = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
          customerInfo.integrationWithDMS = feature;
          let realTimeSync = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive
          customerInfo.realtimeDmsSyncCustomer = realTimeSync;
        }
        if (this.editCustomerOwnerForm.value.isCompany) {
          customerInfo.customerTypeId = 2;
          customerInfo.custName = this.editCustomerOwnerForm.get('customerName').value;
          if (!this.empty(this.editCustomerOwnerForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerOwnerForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        } else {
          customerInfo.customerTypeId = this.editCustomerOwnerForm.get('gender').value == '1' ? 1 : 0;
          customerInfo.custName = this.editCustomerOwnerForm.get('firstName').value + " " + this.editCustomerOwnerForm.get('lastName').value;
          if (!this.empty(this.editCustomerOwnerForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerOwnerForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        }
        break;
      case 'User':
        if(this.customerDetailById)
        {
        customerInfo =
        {
          customerId: customerId,
          firstName: this.empty(this.editCustomerUserForm.get('firstName').value) ? "" : this.editCustomerUserForm.get('firstName').value,
          lastName: this.empty(this.editCustomerUserForm.get('lastName').value) ? "" : this.editCustomerUserForm.get('lastName').value,
          address1: this.editCustomerUserForm.get('address1').value,
          address2: this.editCustomerUserForm.get('address2').value,
          zipcode: this.editCustomerUserForm.get('postCode').value,
          city: this.editCustomerUserForm.get('city').value,
          state: "",
          countryId: this.customerDetailById.countryId,
          mobileNo: this.editCustomerUserForm.get('mobileNo').value?.number ? this.editCustomerUserForm.get('mobileNo').value.number.toString().replace(/\s+/g, '') : this.editCustomerUserForm.get('mobileNo').value,
          mobileCode: this.empty(this.userInputMobilecodeUser)? "" : this.userInputMobilecodeUser.replace("+", ""),
          email: this.editCustomerUserForm.get('email').value,
          latitude: 0,
          longitude: 0,
          customerNo: this.editCustomerUserForm.get('customerNo').value,
          langaugeCode: this.customerDetailById.langaugeCode,
          blocked: this.customerDetailById.blocked,
          phoneNumberCode:this.empty(this.userInputPhoneNumberCodeUser)? "" : this.userInputPhoneNumberCodeUser.replace("+", ""),
          phoneNumber: this.editCustomerUserForm.get('phoneNumber').value?.number ? this.editCustomerUserForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '') : this.editCustomerUserForm.get('phoneNumber').value,
          customerTypeId: this.customerDetailById.customerTypeId,
          custName: "",
          registrationOrPersonNumber: this.customerDetailById.registrationOrPersonNumber,
          registrationOrBirthDate: this.customerDetailById.registrationOrBirthDate,
          customerGroup: this.customerDetailById.customerGroup,
          salutation:  this.customerDetailById.salutation,
          email2: this.customerDetailById.email2,
          fax: this.customerDetailById.fax,
          ownerTypeId: this.customerDetailById.ownerTypeId,
          sourceTypeId: this.customerDetailById.sourceTypeId,
          isActive: this.customerDetailById.isActive,
          isRegularEmail: this.customerDetailById.isRegularEmail,
          isEmail: this.customerDetailById.isEmail,
          isFax: this.customerDetailById.isFax,
          isSms: this.customerDetailById.isSms,
          isPhone: this.customerDetailById.isPhone,
          dataPrivacyStatus: this.customerDetailById.dataPrivacyStatus,
          integrationWithDMS: false,
          moduleId: ModuleNames.Customer,
          countryCode:this.countryList?.find(f => f.id == this.customerDetailById.countryId).code,
          realtimeDmsSyncCustomer:true,
        }
        }
        if (this.features && this.features.length > 0) {
          let feature = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
          customerInfo.integrationWithDMS = feature;
          let realTimeSync = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive
          customerInfo.realtimeDmsSyncCustomer = realTimeSync;
        }
        if (this.editCustomerUserForm.value.isCompany) {
          customerInfo.customerTypeId = 2;
          customerInfo.custName = this.editCustomerUserForm.get('customerName').value;
          if (!this.empty(this.editCustomerUserForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerUserForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        } else {
          customerInfo.customerTypeId = this.editCustomerUserForm.get('gender').value == '1' ? 1 : 0;
          customerInfo.custName = this.editCustomerUserForm.get('firstName').value + " " + this.editCustomerUserForm.get('lastName').value;
          if (!this.empty(this.editCustomerUserForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerUserForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        }
        break;
      case 'Driver':
        if(this.customerDetailById)
        {
        customerInfo =
        {
          customerId: customerId,
          firstName: this.empty(this.editCustomerDriverForm.get('firstName').value) ? "" : this.editCustomerDriverForm.get('firstName').value,
          lastName: this.empty(this.editCustomerDriverForm.get('lastName').value) ? "" : this.editCustomerDriverForm.get('lastName').value,
          address1: this.editCustomerDriverForm.get('address1').value,
          address2: this.editCustomerDriverForm.get('address2').value,
          zipcode: this.editCustomerDriverForm.get('postCode').value,
          city: this.editCustomerDriverForm.get('city').value,
          state: "",
          countryId: this.customerDetailById.countryId,
          mobileNo: this.editCustomerDriverForm.get('mobileNo').value?.number ? this.editCustomerDriverForm.get('mobileNo').value.number.toString().replace(/\s+/g, '') : this.editCustomerDriverForm.get('mobileNo').value,
          mobileCode: this.empty(this.userInputMobilecodeDriver)? "" : this.userInputMobilecodeDriver.replace("+", ""),
          email: this.editCustomerDriverForm.get('email').value,
          latitude: 0,
          longitude: 0,
          customerNo: this.editCustomerDriverForm.get('customerNo').value,
          langaugeCode: this.customerDetailById.langaugeCode,
          blocked: this.customerDetailById.blocked,
          phoneNumberCode:this.empty(this.userInputPhoneNumberCodeDriver)? "" : this.userInputPhoneNumberCodeDriver.replace("+", ""),
          phoneNumber: this.editCustomerDriverForm.get('phoneNumber').value?.number ? this.editCustomerDriverForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '') : this.editCustomerDriverForm.get('phoneNumber').value,
          customerTypeId: this.customerDetailById.customerTypeId,
          custName: "",
          registrationOrPersonNumber: this.customerDetailById.registrationOrPersonNumber,
          registrationOrBirthDate: this.customerDetailById.registrationOrBirthDate,
          customerGroup: this.customerDetailById.customerGroup,
          salutation:  this.customerDetailById.salutation,
          email2: this.customerDetailById.email2,
          fax: this.customerDetailById.fax,
          ownerTypeId: this.customerDetailById.ownerTypeId,
          sourceTypeId: this.customerDetailById.sourceTypeId,
          isActive: this.customerDetailById.isActive,
          isRegularEmail: this.customerDetailById.isRegularEmail,
          isEmail: this.customerDetailById.isEmail,
          isFax: this.customerDetailById.isFax,
          isSms: this.customerDetailById.isSms,
          isPhone: this.customerDetailById.isPhone,
          dataPrivacyStatus: this.customerDetailById.dataPrivacyStatus,
          integrationWithDMS: false,
          moduleId: ModuleNames.Customer,
          countryCode:this.countryList?.find(f => f.id == this.customerDetailById.countryId).code,
          realtimeDmsSyncCustomer:true,
        }
        }
        if (this.features && this.features.length > 0) {
          let feature = this._clientName === 'mg' ? this.features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
          customerInfo.integrationWithDMS = feature;
          let realTimeSync = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSC)?.isActive
          customerInfo.realtimeDmsSyncCustomer = realTimeSync;
        }
        if (this.editCustomerDriverForm.value.isCompany) {
          customerInfo.customerTypeId = 2;
          customerInfo.custName = this.editCustomerDriverForm.get('customerName').value;
          if (!this.empty(this.editCustomerDriverForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerDriverForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        } else {
          customerInfo.customerTypeId = this.editCustomerDriverForm.get('gender').value == '1' ? 1 : 0;
          customerInfo.custName = this.editCustomerDriverForm.get('firstName').value + " " + this.editCustomerUserForm.get('lastName').value;
          if (!this.empty(this.editCustomerDriverForm.get('dob').value)) {
            let registerdate = new Date(Utility.getDateStringToDate(this.editCustomerDriverForm.get('dob').value).getTime() - (temp.getTimezoneOffset() * 60000));
            customerInfo.registrationOrBirthDate = registerdate;
          } else {
            customerInfo.registrationOrBirthDate = "";
          }
        }
        break;
      default:
        break;
    }
    if(customerInfo != null){
      let checkDuplicateCustomerModel = {
        Dial_Code: customerInfo.mobileCode,
        mobileNo: customerInfo.mobileNo,
        fullName: customerInfo.custName,
        email: customerInfo.email
      }
      this.spinner.show();
      let CustomerMobilerCheck = await this.service.CheckCustomerDuplication(checkDuplicateCustomerModel);
      if (CustomerMobilerCheck != null) {
        this.spinner.hide();
        this.duplicateCustomerList = CustomerMobilerCheck;
        this.duplicateCustomerList = this.duplicateCustomerList.filter(x=>x.customerNumber != customerInfo.customerNo);
        if (this.duplicateCustomerList.length > 0) {
          this.spinner.hide();
          this.modalService.open(this.customerDuplication, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            //Saving New customer details
          }, (reason) => {
            if(reason){
              this.updateCustomerDetails(customerInfo);
            }
          });
        }
        else{
          this.spinner.hide();
          this.updateCustomerDetails(customerInfo);
        }
      }
      else{
        this.spinner.hide();
        this.updateCustomerDetails(customerInfo);
      }
    }
  }

  updateCustomerDetails(customerInfo:any){
    let successMessage =this.translate.instant('lblCutsomerDetailEdited');
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")
    this.service.addEditCustomer(customerInfo).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        let responseResult = res.responseObject;
        if (responseResult.isSuccess) {
          this.toaster.success(successMessage);
        } else {
          successMessage = responseResult.resultMessage;
        }

        this.getCustomerDetail(this.vehicleId);
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toaster.warning(errormsg);
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  get cpfPayer() {
    return this.editCustomerPayerForm.controls;
  }
  get cpfOwner() {
    return this.editCustomerOwnerForm.controls;
  }
  get cpfDriver() {
    return this.editCustomerDriverForm.controls;
  }
  get cpfUser() {
    return this.editCustomerUserForm.controls;
  }

  viewCustomer(objCustomer) {
    this.service.customerId = objCustomer.customerId;
    this.service.customerNo = objCustomer.customerNo;
    this.service.customerName = objCustomer.customerName;
    this.service.firstName = objCustomer.firstName;
    this.service.lastName = objCustomer.lastName;

    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = false;
    modalref.componentInstance.fromVehicleCustomerDetails = true;
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  onSearchCustomerNo(customerNo:any,flag: string) {
    const modalref = this.modalService.open(CustomerComponent, { size: 'lg',
       windowClass: 'EditPopup', });
    modalref.componentInstance.fromVehicleScreen = true;
    modalref.componentInstance.customerNo=customerNo;
    modalref.componentInstance.searchThroughLocalDF = this.vehicleBusinessService.searchThroughLocalDF;
    modalref.result.then(async (response) => {
      if (response.success) {
       if(response.customerId)
       {
        await this.service.getCustomerById(response.customerId).then((response) => {
          let customerDetail = response.responseObject as CustomerDetailsViewModel;
          if(this.vehicleBusinessService.searchThroughLocalDF){
            this.patchCustomerFromDFSearch(customerDetail);
          }
          else{
            switch (flag) {
              case 'Payer':
                this.patchCustomerPayerFormValue(customerDetail)
                break;
              case 'Owner':
                this.patchCustomerOwnerFormValue(customerDetail);
                break;
              case 'User':
                this.patchCustomerUserFormValue(customerDetail)
                break;
              case 'Driver':
                let isCompany=customerDetail.customerTypeId == 2 ? true : false;
                if(isCompany)
                {
                  if(this.customerDetails.customerDriver)
                  {
                      this.editCustomerDriverForm.patchValue({
                      customerNo:this.customerDetails.customerDriver.customerNo
                    })
                  }
  
                  let errorMsg = this.translate.instant('lblDriverCannotBeCompany');
                  this.toaster.error(errorMsg);
                }
                else
                {
                  this.patchCustomerDriverFormValue(customerDetail)
                }
                break;
              default:
                break;
            }
            this.spinner.hide();
          }
        },_error => {
          this.spinner.hide();
        });
       }
      }
    });
  }

  patchCustomerFromDFSearch(customerDetail:CustomerDetailsViewModel){
    if(this.vehicleBusinessService.searchThroughLocalDF){
      this.customerMessage = this.translate.instant('lblUpdatingCustomerDetails');
      if(this.vehicleBusinessService.customerRelationType.includes('Payer')){
        this.patchCustomerPayerFormValue(customerDetail);
        this.accordion.expand('Payer');
        this.editCustomerPayerForm.patchValue({
          customerNo: customerDetail.customerNo
        });
        this.userRelations = this.translate.instant('lblPayer')
      }  
      if(this.vehicleBusinessService.customerRelationType.includes('Owner')){
        this.patchCustomerOwnerFormValue(customerDetail);
        this.accordion.expand('Owner');
        this.editCustomerOwnerForm.patchValue({
          customerNo: customerDetail.customerNo
        });
        this.userRelations = this.userRelations != null ? this.userRelations + ', ' + this.translate.instant('lblOwner') : this.translate.instant('lblOwner')
      }
      if(this.vehicleBusinessService.customerRelationType.includes('User')){
        this.patchCustomerUserFormValue(customerDetail);
        this.accordion.expand('User');
        this.editCustomerUserForm.patchValue({
          customerNo: customerDetail.customerNo
        });
        this.userRelations = this.userRelations != null ? this.userRelations + ', ' + this.translate.instant('lblUser') : this.translate.instant('lblUser')
      }
      if(this.vehicleBusinessService.customerRelationType.includes('Driver')){
        let isCompany=customerDetail.customerTypeId == 2 ? true : false;
        if(isCompany)
        {
          if(this.customerDetails.customerDriver)
          {
              this.editCustomerDriverForm.patchValue({
              customerNo:this.customerDetails.customerDriver.customerNo
            })
          }
          let errorMsg = this.translate.instant('lblDriverCannotBeCompany');
          this.toaster.error(errorMsg);
        }
        else
        {
          this.patchCustomerDriverFormValue(customerDetail);
          this.accordion.expand('Driver');
          this.editCustomerDriverForm.patchValue({
            customerNo: customerDetail.customerNo
          });
        }
        this.userRelations = this.userRelations != null ? this.userRelations + ', ' + this.translate.instant('lblDriver') : this.translate.instant('lblDriver')
        this.cdref.detectChanges();
      }
      this.customerMessage = this.customerMessage + this.userRelations;
    }
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }

  patchCustomerPayerFormValue(customerDetail:CustomerDetailsViewModel)
  {
    let companyShow=customerDetail.customerTypeId == 2 ? true : false;
    this.editCustomerPayerForm.patchValue({
      address1:customerDetail.addressLine1,
      address2: customerDetail.addressLine2,
      city: customerDetail.city,
      customerName: customerDetail.customerName,
      customerNo: customerDetail.customerNo,
      dialCode: customerDetail.mobileCode,
      dob: customerDetail.registrationOrBirthDate,
      email: customerDetail.email,
      firstName: customerDetail.firstName,
      isCompany: companyShow,
      lastName: customerDetail.lastName,
      mobileNo: customerDetail.mobileNo,
      phoneNumber: customerDetail.phoneNumber,
      postCode: customerDetail.pincode,
      customerId:customerDetail.id,
      gender: customerDetail.customerTypeId == 1 ? '1' : '0'
    });
    this.postcodeNamePayer=customerDetail.pincode;
    this.cityNamePayer=customerDetail.city;
    this.dobPayer = customerDetail.registrationOrBirthDate;
    this.editCustomerPayerForm.patchValue({
      dob: this.dobPayer
    })
    this.userInputMobilecodePayer = customerDetail.mobileCode !== null && customerDetail.mobileCode !== '0' ? customerDetail.mobileCode : this.userInputMobilecodePayer;
    this.telInputObjectPayer();
    this.userInputPhoneNumberCodePayer = customerDetail.phoneNumberCode !== null && customerDetail.phoneNumberCode !== '0' ? customerDetail.phoneNumberCode : this.userInputPhoneNumberCodePayer;
    this.telInputObjectPhoneNumberPayer();
    this.cdref.detectChanges();
  }

  patchCustomerOwnerFormValue(customerDetail:CustomerDetailsViewModel)
  {
    let companyShow=customerDetail.customerTypeId == 2 ? true : false;
    this.editCustomerOwnerForm.patchValue({
      address1:customerDetail.addressLine1,
      address2: customerDetail.addressLine2,
      city: customerDetail.city,
      customerName: customerDetail.customerName,
      customerNo: customerDetail.customerNo,
      dialCode: customerDetail.mobileCode,
      dob: customerDetail.registrationOrBirthDate,
      email: customerDetail.email,
      firstName: customerDetail.firstName,
      isCompany: companyShow,
      lastName: customerDetail.lastName,
      mobileNo: customerDetail.mobileNo,
      phoneNumber: customerDetail.phoneNumber,
      postCode: customerDetail.pincode,
      customerId:customerDetail.id,
      gender: customerDetail.customerTypeId == 1 ? '1' : '0'
    });
    this.ownerGuid = customerDetail.customerId
    this.postcodeNameOwner=customerDetail.pincode;
    this.cityNameOwner=customerDetail.city;
    this.dobOwner = customerDetail.registrationOrBirthDate ;
    this.editCustomerOwnerForm.patchValue({
      dob: this.dobOwner
    })
    this.userInputMobilecodeOwner = customerDetail.mobileCode !== null && customerDetail.mobileCode !== '0' ? customerDetail.mobileCode : this.userInputMobilecodeOwner;
    this.telInputObjectOwner();
    this.userInputPhoneNumberCodeOwner = customerDetail.phoneNumberCode !== null && customerDetail.phoneNumberCode !== '0' ? customerDetail.phoneNumberCode : this.userInputPhoneNumberCodeOwner;
    this.telInputObjectPhoneNumberOwner();
    this.cdref.detectChanges();
  }

  patchCustomerUserFormValue(customerDetail:CustomerDetailsViewModel)
  {
    let companyShow=customerDetail.customerTypeId == 2 ? true : false;
    this.editCustomerUserForm.patchValue({
      address1:customerDetail.addressLine1,
      address2: customerDetail.addressLine2,
      city: customerDetail.city,
      customerName: customerDetail.customerName,
      customerNo: customerDetail.customerNo,
      dialCode: customerDetail.mobileCode,
      dob: customerDetail.registrationOrBirthDate,
      email: customerDetail.email,
      firstName: customerDetail.firstName,
      isCompany: companyShow,
      lastName: customerDetail.lastName,
      mobileNo: customerDetail.mobileNo,
      phoneNumber: customerDetail.phoneNumber,
      postCode: customerDetail.pincode,
      customerId:customerDetail.id,
      gender: customerDetail.customerTypeId == 1 ? '1' : '0'
    });
    this.postcodeNameUser=customerDetail.pincode;
    this.cityNameUser=customerDetail.city;
    this.dobUser = customerDetail.registrationOrBirthDate;
    this.editCustomerUserForm.patchValue({
      dob: this.dobUser
    })
    this.userInputMobilecodeUser = customerDetail.mobileCode !== null && customerDetail.mobileCode !== '0' ? customerDetail.mobileCode : this.userInputMobilecodeUser;
    this.telInputObjectUser();
    this.userInputPhoneNumberCodeUser = customerDetail.phoneNumberCode !== null && customerDetail.phoneNumberCode !== '0' ? customerDetail.phoneNumberCode : this.userInputPhoneNumberCodeUser;
    this.telInputObjectPhoneNumberUser();
    this.cdref.detectChanges();
  }

  patchCustomerDriverFormValue(customerDetail:CustomerDetailsViewModel)
  {
    let companyShow=customerDetail.customerTypeId == 2 ? true : false;
    this.editCustomerDriverForm.patchValue({
      address1:customerDetail.addressLine1,
      address2: customerDetail.addressLine2,
      city: customerDetail.city,
      customerName: customerDetail.customerName,
      customerNo: customerDetail.customerNo,
      dialCode: customerDetail.mobileCode,
      dob: customerDetail.registrationOrBirthDate,
      email: customerDetail.email,
      firstName: customerDetail.firstName,
      isCompany: companyShow,
      lastName: customerDetail.lastName,
      mobileNo: customerDetail.mobileNo,
      phoneNumber: customerDetail.phoneNumber,
      postCode: customerDetail.pincode,
      customerId:customerDetail.id,
      gender: customerDetail.customerTypeId == 1 ? '1' : '0'
    });
    this.postcodeNameDriver=customerDetail.pincode;
    this.cityNameDriver=customerDetail.city;
    this.dobDriver = customerDetail.registrationOrBirthDate ;
    this.editCustomerDriverForm.patchValue({
      dob: this.dobDriver
    })
    this.userInputMobilecodeDriver = customerDetail.mobileCode !== null && customerDetail.mobileCode !== '0' ? customerDetail.mobileCode : this.userInputMobilecodeDriver;
    this.telInputObjectDriver();
    this.userInputPhoneNumberCodeDriver = customerDetail.phoneNumberCode !== null && customerDetail.phoneNumberCode !== '0' ? customerDetail.phoneNumberCode : this.userInputPhoneNumberCodeDriver;
    this.telInputObjectPhoneNumberDriver();
    this.cdref.detectChanges();
  }


  UpdateVehicleCustomerMapping(isSaveAndClose)
  {
    if(this.vehicleBusinessService.searchThroughLocalDF){
      let modelHeadermsg = this.translate.instant("lblUpdateCustomer");
      let modelBodymsg = this.translate.instant('lblAreYouSureWantToUdateCustomer');
      modelBodymsg = modelBodymsg.replace("{{CustomerNumber}}",this.vehicleBusinessService.existingCustomerNo)
      modelBodymsg = modelBodymsg.replace("{{RelationType}}",this.userRelations)
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result) => {
          // This is intentional
      }, async (reason) => {
          if (reason) {
            await this.vehicleCustomerMapping(isSaveAndClose);
          }
      });
    }
    else{
      this.vehicleCustomerMapping(isSaveAndClose);
    }
  }

  async vehicleCustomerMapping(isSaveAndClose){
    this.spinner.show();
    let SaveVehicleCustomerMapping:VehicleCustomerMappingModel={
      vehicleId:this.vehicleId,
      customerPayerId:this.editCustomerPayerForm.controls['customerId'].value,
      customerNoPayer:this.editCustomerPayerForm.controls['customerNo'].value,
      customerOwnerId:this.editCustomerOwnerForm.controls['customerId'].value,
      customerNoOwner:this.editCustomerOwnerForm.controls['customerNo'].value,
      customerUserId:this.editCustomerUserForm.controls['customerId'].value,
      customerNoUser:this.editCustomerUserForm.controls['customerNo'].value,
      customerDriverId:this.editCustomerDriverForm.controls['customerId'].value,
      customerNoDriver:this.editCustomerDriverForm.controls['customerNo'].value,
      userId:"",
      vin:this.vinNo,
      integrationWithDMS:this.integrationWithDMS,
      moduleId:ModuleNames.Vehicle,
      realtimeDmsSyncVehicle:this.realtimeDmsSyncVehicle,
      licencePlate:this.licencePlate
    }
    await this.vehicleBusinessService.updateVehicleCustomerMapping(SaveVehicleCustomerMapping).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
          let successMsg = this.translate.instant('lblCustomerDetailUpdated')
          this.toaster.success(successMsg);
          if(this.vehicleBusinessService.searchThroughLocalDF){
            this.customerMessage = null;  
            this.vehicleBusinessService.searchThroughLocalDF = false;
          }
          this.ngOnInit();
      }
      else {
        let errorMsg = this.translate.instant('lblErrorMessage');
        this.toaster.error(errorMsg);
      }
      this.spinner.hide();
      if(isSaveAndClose)
        this.activeModal.close({ success: true });
    });
  }

  closeResult = '';

  open(content,contactCustomer:any) {
    this.contactCustomer.customerName=contactCustomer.customerName;
    this.contactCustomer.dialCode="+" + contactCustomer.dialCode;
    this.contactCustomer.mobileNo="+" + contactCustomer.dialCode + " "+contactCustomer.mobileNo;
    this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.contactCustomer.customerName='';
      this.contactCustomer.dialCode='';
      this.contactCustomer.mobileNo='';
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onMobilePayerChange(){
    if(this.editCustomerPayerForm.get('mobileNo').value){
      let len= this.editCustomerPayerForm.get('mobileNo').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>13){
        this.editCustomerPayerForm.get('mobileNo').setValidators([Validators.required, Validators.pattern(/^\d{8,13}$/)]);
        this.editCustomerPayerForm.get('mobileNo').updateValueAndValidity();
      } else {
        this.editCustomerPayerForm.get('mobileNo').setValidators([Validators.required]);
        this.editCustomerPayerForm.get('mobileNo').updateValueAndValidity();
      }
    }
  }
  onLandlinePayerChange(){
    if(this.editCustomerPayerForm.get('phoneNumber').value){
      let len= this.editCustomerPayerForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>10){
        this.editCustomerPayerForm.get('phoneNumber').setValidators([Validators.pattern(/^\d{8,10}$/)]);
        this.editCustomerPayerForm.get('phoneNumber').updateValueAndValidity();
      } else {
        this.editCustomerPayerForm.get('phoneNumber').setValidators([]);
        this.editCustomerPayerForm.get('phoneNumber').updateValueAndValidity();
      }
    }
  }

  
  onMobileOwnerChange(){
    if(this.editCustomerOwnerForm.get('mobileNo').value){
      let len= this.editCustomerOwnerForm.get('mobileNo').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>13){
        this.editCustomerOwnerForm.get('mobileNo').setValidators([Validators.required, Validators.pattern(/^\d{8,13}$/)]);
        this.editCustomerOwnerForm.get('mobileNo').updateValueAndValidity();
      } else {
        this.editCustomerOwnerForm.get('mobileNo').setValidators([Validators.required]);
        this.editCustomerOwnerForm.get('mobileNo').updateValueAndValidity();
      }
    }
  }
  onLandlineOwnerChange(){
    if(this.editCustomerOwnerForm.get('phoneNumber').value){
      let len= this.editCustomerOwnerForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>10){
        this.editCustomerOwnerForm.get('phoneNumber').setValidators([Validators.pattern(/^\d{8,10}$/)]);
        this.editCustomerOwnerForm.get('phoneNumber').updateValueAndValidity();
      } else {
        this.editCustomerOwnerForm.get('phoneNumber').setValidators([]);
        this.editCustomerOwnerForm.get('phoneNumber').updateValueAndValidity();
      }
    }
  }

  
  onMobileUserChange(){
    if(this.editCustomerUserForm.get('mobileNo').value){
      let len= this.editCustomerUserForm.get('mobileNo').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>13){
        this.editCustomerUserForm.get('mobileNo').setValidators([Validators.required, Validators.pattern(/^\d{8,13}$/)]);
        this.editCustomerUserForm.get('mobileNo').updateValueAndValidity();
      } else {
        this.editCustomerUserForm.get('mobileNo').setValidators([Validators.required]);
        this.editCustomerUserForm.get('mobileNo').updateValueAndValidity();
      }
    }
  }
  onLandlineUserChange(){
    if(this.editCustomerUserForm.get('phoneNumber').value){
      let len= this.editCustomerUserForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>10){
        this.editCustomerUserForm.get('phoneNumber').setValidators([Validators.pattern(/^\d{8,10}$/)]);
        this.editCustomerUserForm.get('phoneNumber').updateValueAndValidity();
      } else {
        this.editCustomerUserForm.get('phoneNumber').setValidators([]);
        this.editCustomerUserForm.get('phoneNumber').updateValueAndValidity();
      }
    }
  }

  
  onMobileDriverChange(){
    if(this.editCustomerDriverForm.get('mobileNo').value){
      let len= this.editCustomerDriverForm.get('mobileNo').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>13){
        this.editCustomerDriverForm.get('mobileNo').setValidators([Validators.required, Validators.pattern(/^\d{8,13}$/)]);
        this.editCustomerDriverForm.get('mobileNo').updateValueAndValidity();
      } else {
        this.editCustomerDriverForm.get('mobileNo').setValidators([Validators.required]);
        this.editCustomerDriverForm.get('mobileNo').updateValueAndValidity();
      }
    }
  }
  onLandlineDriverChange(){
    if(this.editCustomerDriverForm.get('phoneNumber').value){
      let len= this.editCustomerDriverForm.get('phoneNumber').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>10){
        this.editCustomerDriverForm.get('phoneNumber').setValidators([Validators.pattern(/^\d{8,10}$/)]);
        this.editCustomerDriverForm.get('phoneNumber').updateValueAndValidity();
      } else {
        this.editCustomerDriverForm.get('phoneNumber').setValidators([]);
        this.editCustomerDriverForm.get('phoneNumber').updateValueAndValidity();
      }
    }
  }
}
